export const ASCENDING = "ASCENDING";
export const DESCENDING = "DESCENDING";